import React, { useEffect, useState } from 'react';
import './agenda.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faClock, faList, faExclamationTriangle, } from '@fortawesome/free-solid-svg-icons'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useAuthServices } from '../../services/useFetch';
import { Citas } from './Citas/Citas';
import { RegistraCita } from './Citas/RegistraCita';
import { RegistraDisponibilidad } from './Disponibilidad/RegistraDisponibilidad';
import { Disponibilidad } from './Disponibilidad/Disponibilidad';

const AgendaProfesional = ({ profesionalSeleccionado }) => {

    const { requestPost } = useAuthServices();

    const [executeConsulta, setExecuteConsulta] = useState(true)
    const [modalError, setModalError] = useState(false)

    const [menu, setMenu] = useState([
        { element: 'buttom1', label: 'Citas', icon: faList, class: 'btn btn-link p-menu-selector-agenda-active', state: true },
        { element: 'buttom2', label: 'Agendar cita', icon: faCalendar, class: 'btn btn-link p-menu-selector-agenda', state: false },
        { element: 'buttom3', label: 'Disponibilidad', icon: faList, class: 'btn btn-link p-menu-selector-agenda', state: false },
        { element: 'buttom4', label: 'Definir disponibilidad', icon: faClock, class: 'btn btn-link p-menu-selector-agenda', state: false },
    ])

    const [citasList, setCitasList] = useState([])

    useEffect(() => {
        obtieneListadoCitasService();
    }, [executeConsulta]);

    const obtieneListadoCitasService = async () => {
        if (!!profesionalSeleccionado) {
            const body = {
                idUsuario: profesionalSeleccionado.id
            }
            const response = await requestPost(body, 11);
            if (!response.error) {
                const { estado, objeto } = response.data
                if (estado) {
                    setCitasList(objeto)
                }
            } else {
                setModalError(true)
            }
        }
    }

    const handleCloseError = () => {
        setModalError(false)
    }

    const executeMenu = (e) => {
        setMenu((elements) => {
            const hMap = elements.map((element) => {
                element.class = (e.target.name === element.element) ? 'btn btn-link p-menu-selector-agenda-active' : 'btn btn-link p-menu-selector-agenda'
                element.state = (e.target.name === element.element) ? true : false
                return element
            })
            return hMap;
        });
    }

    const displayMenu = () => {
        let object = {};
        menu.map((element) => {
            if (element.state) {
                object = element;
            }
            return object;
        })
        switch (object.element) {
            case 'buttom1':
                return (
                    <Citas citasList={citasList} executeConsulta={executeConsulta} setExecuteConsulta={setExecuteConsulta} origen="AGENDA" />
                )
            case 'buttom2':
                return (
                    <RegistraCita executeConsulta={executeConsulta} setExecuteConsulta={setExecuteConsulta} profesionalSeleccionado={profesionalSeleccionado} />
                )
            case 'buttom3':
                return (
                    <Disponibilidad profesionalSeleccionado={profesionalSeleccionado} />
                )
            case 'buttom4':
                return (
                    <RegistraDisponibilidad executeMenu={executeMenu} profesionalSeleccionado={profesionalSeleccionado} />
                )
            default:
                return (
                    <></>
                )
        }
    }

    return (
        <>
            <div className='div-container-db-agenda-profesional' >
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                        <div className="div-menu-selector-agenda-container mt-0">
                            <div className="div-menu-selector-agenda">
                                {
                                    menu.map((object, index) => {
                                        return (
                                            <button key={index} name={object.element} className={object.class} onClick={executeMenu} >
                                                <FontAwesomeIcon icon={object.icon} /> {object.label}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='div-container-db-agenda'>
                {
                    displayMenu()
                }
            </div >
            <Modal isOpen={modalError} onHide={handleCloseError} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>Error de comunicación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>Vaya, tenemos algunas dificultades de comunicación en este momento, por favor intenta mas tarde.</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseError}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )

}

export default AgendaProfesional;